import React from "react";
import TrackingItem from "../../../single-items/TrackingItem";

const TrackingDetails = ({ data }) => {
  // console.log(data?.status, "Status", data?.notes, "Notes");
  const stageOrder = [
    "processing",
    "confirmed",
    "shipped",
    "outForDelivery",
    "delivered",
  ];
  const currentStageIndex = stageOrder.indexOf(data?.status);

  const dynamicTrackingData = [
    {
      _id: 1,
      icon: "fa-light fa-box",
      name: "Order Confirmed",
      statusKey: "confirmed",
      date: {
        dayname: "Thu",
        day: "12",
        month: "June",
        year: "2025",
      },
      subdata: [
        {
          name: "",
          description: data?.notes || "Your order has been placed.",
          status:
            stageOrder.indexOf("confirmed") <= currentStageIndex
              ? "completed"
              : "pending",
          date: {
            dayname: "Thu",
            day: "12",
            month: "June",
            year: "2025",
            time: "13:20",
          },
        },
      ],
    },
    {
      _id: 2,
      icon: "fa-light fa-truck-fast",
      name: "Shipped",
      statusKey: "shipped",
      date: {
        dayname: "Fri",
        day: "13",
        month: "June",
        year: "2025",
      },
      subdata: [
        {
          name: `${data?.logistics || ""} - ${data?.trackingNo || ""}`,
          description: "Your order has been shipped.",
          status:
            stageOrder.indexOf("shipped") <= currentStageIndex
              ? "completed"
              : "pending",
          date: {
            dayname: "Fri",
            day: "13",
            month: "June",
            year: "2025",
            time: "11:00",
          },
        },
      ],
    },
    {
      _id: 3,
      icon: "fa-light fa-truck-ramp-box",
      name: "Out For Delivery",
      statusKey: "outForDelivery",
      date: {
        dayname: "Sat",
        day: "14",
        month: "June",
        year: "2025",
      },
      subdata: [
        {
          name: "",
          description: "Your order is out for delivery.",
          status:
            stageOrder.indexOf("outForDelivery") <= currentStageIndex
              ? "completed"
              : "pending",
          date: {
            dayname: "Sat",
            day: "14",
            month: "June",
            year: "2025",
            time: "14:00",
          },
        },
      ],
    },
    {
      _id: 4,
      icon: "fa-light fa-badge-check",
      name: "Delivered",
      statusKey: "delivered",
      date: {
        dayname: "Sun",
        day: "15",
        month: "June",
        year: "2025",
      },
      subdata: [
        {
          name: "",
          description: "Your order has been delivered.",
          status:
            stageOrder.indexOf("delivered") <= currentStageIndex
              ? "completed"
              : "pending",
          date: {
            dayname: "Sun",
            day: "15",
            month: "June",
            year: "2025",
            time: "15:00",
          },
        },
      ],
    },
  ].map((stage) => ({
    ...stage,
    statuspercentage:
      stageOrder.indexOf(stage.statusKey) <= currentStageIndex ? 100 : 7,
  }));

  return (
    <>
      <div className="relative bg-white py-4 px-4 shadow shadow-md-pink/20 rounded-lg">
        <div className="mb-4 pb-4 border-b border-md-pink-light-1 flex items-center justify-between gap-4 flex-wrap">
          <div className="text-lg 2xl:text-xl text-md-dark font-semibold">
            Tracking Details
          </div>
          <div className="w-full grid grid-cols-2">
            <div className="space-y-0.5 flex flex-col items-start">
              <div className="text-[10px] 2xl:text-xs uppercase !leading-none text-slate-400 tracking-wide">
                Logistics
              </div>
              <div className="text-sm 2xl:text-base font-medium !leading-none">
                {data?.logistics}
              </div>
            </div>
            <div className="space-y-0.5 flex flex-col items-end">
              <div className="text-[10px] 2xl:text-xs uppercase !leading-none text-slate-400 tracking-wide">
                Tracking No.
              </div>
              <div className="text-sm 2xl:text-base font-medium !leading-none">
                {data?.trackingNo}
              </div>
            </div>
          </div>
        </div>
        {dynamicTrackingData?.length > 0 && (
          <div className="relative">
            {dynamicTrackingData?.map((item, index) => (
              <TrackingItem
                key={index}
                data={item}
                index={index}
                length={dynamicTrackingData?.length}
              />
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default TrackingDetails;
